import { render, staticRenderFns } from "./SelectStatusAutoClaim.vue?vue&type=template&id=0915b044&"
import script from "./SelectStatusAutoClaim.vue?vue&type=script&lang=js&"
export * from "./SelectStatusAutoClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports